import { le as C } from "./focus-trap.esm-DaVNyTE9.js";
import { h$1 as O, u$1 as p, c as h, Y as x, v as z, h as d, a as L, me as T } from "./register-Ba9sFUKZ.js";
import { d as m } from "./query-DoAo5UXi.js";
import { e as E } from "./if-defined-_sZbHAlG.js";
import { A as $ } from "./passthroughAttributes-C4XaYcZ0.js";
import { v as B } from "./mixin-CP6jLr_x.js";
import { d as j } from "./opens-by-DP5hIiRc.js";
import { c as y, d as f, f as g } from "./lifecycle-decorators-C04d1yHY.js";
import { n as M, c as u } from "./scroll-CyO1WAss.js";
function S(o) {
  return typeof o == "function" && o.length === 1;
}
const A = O`:host(:not([focus-override])) .non-modal-dialog-background-wrapper+dialog:focus-visible{position:fixed;z-index:2}dialog{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-200);background-color:var(--beacon-system-color-background-1);border:0;color:unset;inline-size:var(--beacon-modal-override-width, var(--default-width, 100%));max-inline-size:var(--beacon-modal-override-max-width, var(--max-width));min-inline-size:var(--min-width);padding:0}dialog::backdrop{background-color:var(--beacon-system-color-background-blanket)}.block-size-wrapper{block-size:var(--beacon-modal-override-height, auto)}.non-modal-dialog-background-wrapper+dialog{position:fixed;z-index:2}.non-modal-dialog-background-wrapper{background-color:var(--beacon-system-color-background-blanket);block-size:100%;inline-size:100%;top:0;right:0;bottom:0;left:0;position:fixed;z-index:1}.wrapper{block-size:100%;display:grid;grid-template-rows:auto 1fr auto}.header{border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);display:flex;justify-content:var(--header-justification, end);padding:var(--beacon-system-space-cell-contained)}.body{overflow-y:auto;scrollbar-color:var(--beacon-component-scrollbar-color-background-thumb) var(--beacon-component-scrollbar-color-background-track);scrollbar-gutter:stable}.action-zone{display:flex;gap:var(--beacon-system-space-micro-jumbo);justify-content:end}.footer{border-block-start:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-1);padding:var(--beacon-system-space-cell-contained)}`;
var v = (o) => {
  throw TypeError(o);
}, w = (o, e, t) => e.has(o) || v("Cannot " + t), _ = (o, e, t) => (w(o, e, "read from private field"), t ? t.call(o) : e.get(o)), D = (o, e, t) => e.has(o) ? v("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(o) : e.set(o, t), b = (o, e, t, r) => (w(o, e, "write to private field"), e.set(o, t), t), F = Object.defineProperty, P = Object.getOwnPropertyDescriptor, a = (o, e, t, r) => {
  for (var i = r > 1 ? void 0 : r ? P(e, t) : e, c = o.length - 1, l; c >= 0; c--)
    (l = o[c]) && (i = (r ? l(e, t, i) : l(i)) || i);
  return r && i && F(e, t, i), i;
}, n;
const k = class extends B(T).with(j) {
  constructor() {
    super(...arguments), D(this, n), this._passthroughs = new $(this), this.closeOnClickOut = !1, this.persist = !1, b(this, n, !1);
  }
  static get styles() {
    return [super.styles, A];
  }
  get open() {
    return _(this, n);
  }
  set open(e) {
    b(this, n, e), this.dialog && (this.open ? this.openModal() : this.closeModal());
  }
  handleEvent(e) {
    const t = this[`handle${e.type}`];
    S(t) && t.bind(this)(e);
  }
  /**
   * External click handler used for the handleEvent method.
   *
   * @see handleEvent
   * @see setupOpensByListeners
   */
  handleclick({ target: e }) {
    var t;
    e instanceof HTMLElement && (t = this.opensByElements) != null && t.has(e) && this.show();
  }
  show() {
    this.open = !0;
  }
  close() {
    this.open = !1;
  }
  activateFocusTrap() {
    this.focusTrapObject && this.focusTrapObject.activate();
  }
  /*
   * TODO: Remove the OneTrust workaround.
   * We have worked with the Enterprise team to use dialog.show() instead of dialog.showModal() so that
   * they can have a separate modal pop above our modal. This is all a wacky workaround, so we will prefer
   * to find a different solution in the future. This change has resulted in the below if statement, as well
   * as the activateFocusTrap() method, and assorted CSS changes. For specific changes, look to MR 1900 in Beacon Foundation:
   * https://gitlab.awstrp.net/ui-kit/foundation/-/merge_requests/1900
   */
  openModal() {
    this.anyComputedZIndex ? this.dialog.show() : (this.dialog.showModal(), this.activateFocusTrap()), M(), p(this, h.OPEN);
  }
  closeModal() {
    this.focusTrapObject && this.focusTrapObject.deactivate(), this.dialog.close(), u(), p(this, h.CLOSE);
  }
  renderCloseButton() {
    return this.persist ? x`` : z`
      <${this.getScopedTag("beacon-icon-button")} class="close-button" variant="tertiary" @click=${this.close} id="${E(this._passthroughs.attributes.get("id"))}">
        <svg
          class="icon--close"
          slot="icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.4697 19.5303C18.7626 19.8232 19.2374 19.8232 19.5303 19.5303C19.8232 19.2374 19.8232 18.7626 19.5303 18.4697L13.0607 12L19.5303 5.53033C19.8232 5.23744 19.8232 4.76256 19.5303 4.46967C19.2374 4.17678 18.7626 4.17678 18.4697 4.46967L12 10.9393L5.53033 4.46967C5.23744 4.17678 4.76256 4.17678 4.46967 4.46967C4.17678 4.76256 4.17678 5.23744 4.46967 5.53033L10.9393 12L4.46967 18.4697C4.17678 18.7626 4.17678 19.2374 4.46967 19.5303C4.76256 19.8232 5.23744 19.8232 5.53033 19.5303L12 13.0607L18.4697 19.5303Z"
            fill="#0063AD"
          />
        </svg>
        <slot name="close-button-text">Close</slot>
      </${this.getScopedTag("beacon-icon-button")}>
    `;
  }
  handleDialogClick(e) {
    this.persist || !this.closeOnClickOut || e.composedPath().includes(this.contentWrapper) || this.close();
  }
  runOpensBySetup() {
    this.opensByElements.forEach(
      (e, t) => t.addEventListener(
        "click",
        this
      )
    );
  }
  runOpensByClean() {
    this.opensByElements.forEach(
      (e, t) => t.removeEventListener(
        "click",
        this
      )
    );
  }
  setupAnalyticsAttributes() {
    this.dataset.metricsLocation = "PU";
  }
  initializeAnyComputedZIndex() {
    this.anyComputedZIndex = window.getComputedStyle(this).getPropertyValue("z-index") !== "auto";
  }
  openModalOnLoad() {
    this.open && this.openModal();
  }
  initializeFocusTrap() {
    window.__beaconTrapStack || (window.__beaconTrapStack = []), this.focusTrapObject = C(this, {
      /** This global var enables multiple layers of focusTraps to determine which focusTrap takes precendence.
       * focus-trap will dynamically pause lower focusTrap layers in the stack.
       * https://github.com/focus-trap/focus-trap/blob/master/docs/js/global-trap-stack.js#L13
       * */
      trapStack: window.__beaconTrapStack,
      fallbackFocus: this.dialog,
      // focusTrap needs a fallbackFocus node if there are no focusable nodes found in the host element
      tabbableOptions: {
        getShadowRoot: !0
        // option that allows focusTrap to penetrate closed shadowRoot's and grab focusable nodes
      },
      // this is where escape key properly sets properties
      escapeDeactivates: () => (this.close(), !0)
    });
  }
  removeOpensByListeners() {
    this.opensByElements && this.opensByElements.size > 0 && this.opensByElements.forEach(
      (e, t) => t.removeEventListener(
        "click",
        this
      )
    );
  }
  closeWhenDisconnected() {
    this.open && (this.focusTrapObject && this.focusTrapObject.deactivate(), u());
  }
};
n = /* @__PURE__ */ new WeakMap(), k.nestedComponents = ["beacon-icon-button"];
let s = k;
a([
  d({ attribute: "close-on-click-out", type: Boolean })
], s.prototype, "closeOnClickOut", 2);
a([
  d({ type: Boolean })
], s.prototype, "persist", 2);
a([
  d({ type: Boolean, reflect: !0 })
], s.prototype, "open", 1);
a([
  m("dialog")
], s.prototype, "dialog", 2);
a([
  m(".wrapper")
], s.prototype, "contentWrapper", 2);
a([
  L()
], s.prototype, "anyComputedZIndex", 2);
a([
  y
], s.prototype, "setupAnalyticsAttributes", 1);
a([
  y
], s.prototype, "initializeAnyComputedZIndex", 1);
a([
  f
], s.prototype, "openModalOnLoad", 1);
a([
  f
], s.prototype, "initializeFocusTrap", 1);
a([
  g
], s.prototype, "removeOpensByListeners", 1);
a([
  g
], s.prototype, "closeWhenDisconnected", 1);
export {
  s as i
};
